import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useLocalStorage } from '../CustomHooks/useLocalStorage';

import { setUserInfo } from '../actions';

import { ComparisonSummary } from './RatesSummary/ComparisonSummary';

import { TOKEN, LOGOUT, handleSettingsClick } from '../constants';

export const RatesComparisonSummary = () => {
  const { jwt, user } = useSelector(({ userReducer: { user, jwt }, residencyReducer }) => ({
    user,
    jwt,
    residencyReducer,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value] = useLocalStorage(TOKEN);

  useEffect(() => {
    if (!value && !jwt) {
      navigate('/login');
      return;
    }
    if (value || jwt) {
      if (!localStorage.getItem(TOKEN)) {
        return;
      }
      const user = atob(localStorage.getItem(TOKEN)?.split('.')?.[1]);
      const parsedUser = JSON.parse(user);

      if (parsedUser) {
        const date = new Date(parsedUser.exp * 1000);
        const now = new Date();
        if (date < now) {
          handleSettingsClick[LOGOUT]?.(dispatch, parsedUser);
        }

        dispatch((dispatch) => setUserInfo(dispatch, parsedUser));
      }
    }
  }, [value, jwt]);

  if (!value) {
    navigate('/login');
  }

  return <ComparisonSummary user={user} tokenValue={jwt || value} />;
};
